<template>
  <el-form :inline="true" class="mainSearch">
    <el-page-header @back="goback" style="margin-bottom: 20px">
      <template #content>
        <span class="text-large font-600 mr-3">{{ title }} </span>
      </template>
    </el-page-header>
  </el-form>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-row :gutter="20">
        <el-col :span="12"
          ><div class="grid-content ep-bg-purple">
            订单状态：
            <el-tag class="ml-2" round type="danger">{{
              util.showOrderStatus(orderInfo.orderstatus)
            }}</el-tag>
            售后类型：
            <el-tag class="ml-2" round type="success">{{
              util.showSaleType(orderInfo.orderSales.saletype)
            }}</el-tag>
            售后状态：
            <el-tag class="ml-2" round>{{
              util.showSaleStatus(orderInfo.orderSales.salestatus)
            }}</el-tag>
          </div></el-col
        >
        <el-col :span="12">
          <div class="grid-content ep-bg-purple" style="text-align:right">
            <el-button type="primary" @click="doBatchSaveSaleStatus" v-hasPermission="['sale:cancel']">作废</el-button>
            <el-button type="danger" @click="showSaleOptionDialog" v-hasPermission="['sale:edit']">售后</el-button>
          </div>
        </el-col>
      </el-row>
      <el-divider />
      <el-descriptions title="订单售后信息" :column="2">
        <el-descriptions-item label="申请时间">
          {{
            util.formatDateUnix(
              orderInfo.orderSales.applyed,
              "yyyy-MM-dd hh:mm"
            )
          }}
        </el-descriptions-item>
        <el-descriptions-item label="售后类型">{{
          util.showSaleType(orderInfo.orderSales.saletype)
        }}</el-descriptions-item>
        <el-descriptions-item label="售后完成时间">{{
          util.formatDateUnix(
            orderInfo.orderSales.salecompleted,
            "yyyy-MM-dd hh:mm"
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="售后状态">{{
          util.showSaleStatus(orderInfo.orderSales.salestatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="供应商货款事宜">{{
          util.showSaleSupplieramount(orderInfo.orderSales.supplieramount)
        }}</el-descriptions-item>
        <el-descriptions-item label="售后说明">{{
          orderInfo.orderSales.salenote
        }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="订单基本信息" :column="2">
        <el-descriptions-item label="平台交易时间">{{
          util.formatDateUnix(orderInfo.platformed, "yyyy-MM-dd hh:mm")
        }}</el-descriptions-item>
        <el-descriptions-item label="垚旌导入时间">{{
          util.formatDateUnix(orderInfo.created, "yyyy-MM-dd hh:mm")
        }}</el-descriptions-item>
        <el-descriptions-item label="平台订单号">{{
          orderInfo.platformnum
        }}</el-descriptions-item>
        <el-descriptions-item label="垚旌订单号">{{
          orderInfo.ordernum
        }}</el-descriptions-item>
        <el-descriptions-item label="订单类型">{{
          util.showOrderType(orderInfo.ordertype)
        }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{
          util.showOrderStatus(orderInfo.orderstatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="收货人姓名">{{
          orderInfo.orderAddress.receiver
        }}</el-descriptions-item>
        <el-descriptions-item label="收货人电话">{{
          orderInfo.orderAddress.receiverphone
        }}</el-descriptions-item>
        <el-descriptions-item label="收货地址" :span="2">{{
          orderInfo.orderAddress.receiveraddress
        }}</el-descriptions-item>
        <el-descriptions-item label="订单完成时间"><span v-if="orderInfo.completed">{{
          util.formatDateUnix(orderInfo.completed, "yyyy-MM-dd hh:mm")
        }}</span></el-descriptions-item>
        <el-descriptions-item label="客户下单备注">{{
          orderInfo.ordernote
        }}</el-descriptions-item>

        <el-descriptions-item label="异常订单状态">{{util.showOrderAbnormalStatus(orderInfo.abnormalstatus)}}</el-descriptions-item>
        <el-descriptions-item label="异常订单备注">{{orderInfo.abnormalnote}}</el-descriptions-item>
        <el-descriptions-item label="异常订单备注时间">{{orderInfo.abnormaled}}</el-descriptions-item>
        <el-descriptions-item label="订单备注1">{{orderInfo.ordernote1}}</el-descriptions-item>
        <el-descriptions-item label="订单备注2">{{orderInfo.ordernote2}}</el-descriptions-item>
        <el-descriptions-item label="订单备注3">{{orderInfo.ordernote3}}</el-descriptions-item>
        <el-descriptions-item label="订单标识">{{orderInfo.orderidentifier}}</el-descriptions-item>

      </el-descriptions>
      <el-divider />
      <el-descriptions title="订单金额信息" :column="2">
       
        <el-descriptions-item label="销售金额">¥ 
          <span v-if="orderInfo.saleamount" v-text="( orderInfo.saleamount).toFixed(2)" />
        </el-descriptions-item>
        <el-descriptions-item label="成本金额">¥ 
          <span v-if="orderInfo.costamount" v-text="( orderInfo.costamount).toFixed(2)" />
        </el-descriptions-item>
        <el-descriptions-item label="实发数量"
          >{{ orderInfo.realqty }}</el-descriptions-item
        >
        <el-descriptions-item label="毛利额">¥ 
          <span v-if="orderInfo.maolieamount" v-text="( orderInfo.maolieamount).toFixed(2)" />
        </el-descriptions-item>
        <el-descriptions-item label="毛利率">
          <span v-if="orderInfo.maoliv" v-text="(orderInfo.maoliv*100).toFixed(2) + '%'" />
          <el-tag
            round
            :type="
              orderInfo.maoliv >= orderInfo.customer.maoliv &&
              orderInfo.maoliv <= orderInfo.customer.maolivge
                ? 'success'
                : 'danger'
            "
            disable-transitions
            ><span
              v-text="
                util.showOrderMaoliv(
                  orderInfo.maoliv >= orderInfo.customer.maoliv &&
                    orderInfo.maoliv <= orderInfo.customer.maolivge
                    ? 1
                    : 2
                )
              "
            ></span> </el-tag>
        </el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="订单商品信息" :column="2">
        <el-descriptions-item label="供应商商品ID">{{
          orderInfo.orderGoods.sgoodsnum
        }}</el-descriptions-item>
        <el-descriptions-item label="商品ID">{{
          orderInfo.orderGoods.goodsnum
        }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{
          orderInfo.name
        }}</el-descriptions-item>
        <el-descriptions-item label="商品类目">{{
          orderInfo.orderGoods.catalogname
        }}</el-descriptions-item>
        <el-descriptions-item label="商品品牌">{{
          orderInfo.orderGoods.brandname
        }}</el-descriptions-item>
        <el-descriptions-item label="商品品牌ID">{{
          orderInfo.orderGoods.brandid
        }}</el-descriptions-item>
        <el-descriptions-item label="商品类型">{{
          orderInfo.orderGoods.typename
        }}</el-descriptions-item>
        <el-descriptions-item label="商品规格">{{
          orderInfo.orderGoods.specification
        }}</el-descriptions-item>
        <el-descriptions-item label="商品描述">{{
          orderInfo.orderGoods.desc
        }}</el-descriptions-item>
        <el-descriptions-item label="税收编码">{{
          orderInfo.orderGoods.taxcode
        }}</el-descriptions-item>
        <el-descriptions-item label="税收分类名称">{{
          orderInfo.orderGoods.taxsort
        }}</el-descriptions-item>
        <el-descriptions-item label="国际条形码">{{
          orderInfo.orderGoods.barcode
        }}</el-descriptions-item>
        <el-descriptions-item label="礼包单品SKU编码">{{
          orderInfo.orderGoods.giftsku
        }}</el-descriptions-item>
        <el-descriptions-item label="电商评价数">{{
          orderInfo.orderGoods.erate
        }}</el-descriptions-item>
        <el-descriptions-item label="电商链接">{{
          orderInfo.orderGoods.elink
        }}</el-descriptions-item>
        <el-descriptions-item label="产地">{{
          orderInfo.orderGoods.producer
        }}</el-descriptions-item>
        <el-descriptions-item label="发货快递要求">{{
          orderInfo.orderGoods.expressdemand
        }}</el-descriptions-item>
        <el-descriptions-item label="商品备注1">{{
          orderInfo.orderGoods.note1
        }}</el-descriptions-item>
        <el-descriptions-item label="商品备注2">{{
          orderInfo.orderGoods.note2
        }}</el-descriptions-item>
        <el-descriptions-item label="发货地">{{
          orderInfo.orderGoods.delivery
        }}</el-descriptions-item>
        <el-descriptions-item label="发货快递">{{
          orderInfo.orderGoods.express
        }}</el-descriptions-item>
        <el-descriptions-item label="成本价">¥ 
          <span v-if="orderInfo.orderGoods.costprice" v-text="(orderInfo.orderGoods.costprice).toFixed(2)" />
        </el-descriptions-item>
        <el-descriptions-item label="市场价">¥ 
          <span v-if="orderInfo.orderGoods.marketprice" v-text="(orderInfo.orderGoods.marketprice).toFixed(2)" />
        </el-descriptions-item>
        <el-descriptions-item label="商品折扣">
          <span v-if="orderInfo.orderGoods.discount" v-text="(orderInfo.orderGoods.discount*100).toFixed(2) + '%'" />
        </el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="订单发货信息" :column="2">
        <el-descriptions-item label="快递单号">{{
          orderInfo.orderAddress.expressnum
        }}</el-descriptions-item>
        <el-descriptions-item label="快递公司">{{
          orderInfo.orderAddress.expresscompany
        }}</el-descriptions-item>
        <el-descriptions-item label="发货时间">{{
          util.formatDateUnix(
            orderInfo.orderAddress.deliveryed,
            "yyyy-MM-dd hh:mm"
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="运费金额">¥ 
          <span v-if="orderInfo.orderAddress.freightamount" v-text="(orderInfo.orderAddress.freightamount).toFixed(2)" />
        </el-descriptions-item>
        <el-descriptions-item label="后端处理备注">{{ orderInfo.orderAddress.deliverynote }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider />
      
      <el-descriptions title="客户信息" :column="2">
        <el-descriptions-item label="客户">{{
          orderInfo.customer.name
        }}</el-descriptions-item>
        <el-descriptions-item label="客户ID">{{
          orderInfo.customer.customerid
        }}</el-descriptions-item>
        <el-descriptions-item label="收款方式">{{
          util.showPaidWay(orderInfo.customer.paidway)
        }}</el-descriptions-item>
        <el-descriptions-item label="收款金额">¥ 
          <span v-if="orderInfo.orderVerify.cuspaidamount" v-text="( orderInfo.orderVerify.cuspaidamount).toFixed(2)" />
        </el-descriptions-item>
        <el-descriptions-item label="收款账户">{{
          orderInfo.customer.paidaccount
        }}</el-descriptions-item>
        <el-descriptions-item label="有无合同">{{
          util.showYesNo(orderInfo.customer.iscontract)
        }}</el-descriptions-item>
        <el-descriptions-item label="账期">{{
          util.supplierAccount(orderInfo.customer.isaccount)
        }}</el-descriptions-item>
        <el-descriptions-item label="客户对账时间">{{
          util.formatDateUnix(
            orderInfo.orderVerify.cuspaided,
            "yyyy-MM-dd hh:mm"
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="有无开票">{{
          util.showYesNo(orderInfo.orderVerify.cusistax)
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="发票类型">{{
          util.showInvoiceType(orderInfo.orderVerify.custaxtype)
        }}</el-descriptions-item> -->
        <el-descriptions-item label="开票税点">{{
          orderInfo.customer.taxpoint
        }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="供应商信息" :column="2">
        <el-descriptions-item label="供应商">{{
          orderInfo.supplier.name
        }}</el-descriptions-item>
        <el-descriptions-item label="供应商ID">{{
          orderInfo.supplier.supplierid
        }}</el-descriptions-item>
        <el-descriptions-item label="付款方式">{{
          util.showPayWay(orderInfo.supplier.payway)
        }}</el-descriptions-item>
        <el-descriptions-item label="付款金额">¥ 
          <span v-if="orderInfo.orderVerify.suppayamount" v-text="( orderInfo.orderVerify.suppayamount).toFixed(2)" />
        </el-descriptions-item>
        <!-- <el-descriptions-item label="付款账户">{{
          orderInfo.supplier.payaccount
        }}</el-descriptions-item> -->
        <el-descriptions-item label="有无合同">{{
          util.showYesNo(orderInfo.supplier.iscontract)
        }}</el-descriptions-item>
        <el-descriptions-item label="账期">{{
          util.supplierAccount(orderInfo.supplier.isaccount)
        }}</el-descriptions-item>
        <el-descriptions-item label="供应商对账时间">{{
          util.formatDateUnix(
            orderInfo.orderVerify.suppayed,
            "yyyy-MM-dd hh:mm"
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="有无开票">{{
          util.showYesNo(orderInfo.orderVerify.supistax)
        }}</el-descriptions-item>
        <el-descriptions-item label="开票类型">{{
          util.showInvoiceType(orderInfo.supplier.taxtype)
        }}</el-descriptions-item>
        <el-descriptions-item label="开票税点">{{
          orderInfo.supplier.taxpoint
        }}</el-descriptions-item>
      </el-descriptions>
    </el-col>
  </el-row>
  
  <SaleOption ref="RefSaleOption" @click="getOrderInfos" />

</template>
<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { getOrderInfo } from "@/api/order";
import { batchSaveSaleStatus } from "@/api/order/sale";
import util from "@/util/tool.js";

import SaleOption from "@/components/common/saleOption";


const router = useRouter();

const orderid = ref(router.currentRoute.value.params.id);
const title = ref();//router.currentRoute.value.query.name

let orderInfo = ref({
  orderid: null,
  supplierid: null,
  customerid: null,
  name: "",
  platformnum: "",
  ordernum: "",
  ordertype: "",
  saleamount: "",
  costamount: "",
  maolieamount: "",
  maoliv: "",
  maolivstatus: "",
  orderstatus: "",
  ordernote: "",
  platformed: "",
  completed: "",
  created: "",
  changed: "",
  orderSales: {
    saleid:"",
    applyed: "",
    reason: "",
    salecompleted: "",
    salenote: "",
    salestatus: "",
    saletype: "",
    supplieramount: "",
  },
  orderAddress: {
    receiver: "",
    receiverphone: "",
    receiveraddress: "",
    expressnum: "",
    expresscompany: "",
    deliveryed: "",
    freightamount: "",
    deliverynote: "",
  },
  orderGoods: {
    goodis:"",
    goodsnum: "",
    sgoodsnum: "",
    goodsname: "",
    catalogname: "",
    brandname: "",
    specification: "",
    costprice: "",
    marketprice: "",
    discount:"",
    desc: "",
    taxcode: "",
    taxsort: "",
    barcode: "",
    erate: "",
    elink: "",
    producer: "",
    note1: "",
    note2: "",
    delivery: "",
    express: "",
  },
  orderVerify: {
    cuscompensation: "",
    cusistax: "",
    cuspaidamount: "",
    cussetstatus: "",
    cusstatus: "",
    cuspaided: "",
    custaxtype: "",
    supcompensation: "",
    supistax: "",
    suppayamount: "",
    supsetstatus: "",
    supstatus: "",
    suppayed: "",
    suptaxtype: "",
  },
  customer: {
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    paidway: "",
    paidaccount: "",
    maoliv: "",
    maolivge: "",
  },
  supplier: {
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    payway: "",
    payaccount: "",
    taxpoint: "",
    taxtype:"",
  },
});
//返回
const goback = () => {
  router.go(-1);
};

//订单售后
let dialogSaleOptionVisible = ref(false);
const RefSaleOption = ref();
const showSaleOptionDialog = () => {
  RefSaleOption.value.changeVisible(!dialogSaleOptionVisible.value);
  RefSaleOption.value.saleMethod({
    applyed: orderInfo.value.orderSales.applyed,
    saletype: orderInfo.value.orderSales.saletype,
    reason: orderInfo.value.orderSales.reason,
    salestatus: orderInfo.value.orderSales.salestatus,
    supplieramount: orderInfo.value.orderSales.supplieramount,
    salenote: orderInfo.value.orderSales.salenote,
    orderid: orderInfo.value.orderid,
    saleid: orderInfo.value.orderSales.saleid
  });
};

//作废
const doBatchSaveSaleStatus = () => {
    let orders = [{orderid:orderInfo.value.orderid,salestatus:3}];
    batchSaveSaleStatus(orders).then((res) => {
        if (res.data.code === 1) {
          orderInfo.value.orderSales.salestatus = 3
        } else {
          ElMessage.error(res.data.msg);
        }
    });
  
};

//详情
const getOrderInfos = () => {
  getOrderInfo({ orderid: orderid.value }).then((res) => {
    orderInfo.value = res.data.extend.order;
    title.value = orderInfo.value.name;
  });
}

//onMounted方法
onMounted(() => {
  getOrderInfos()
});
</script>
<style scoped>
.el-descriptions__table {
  width: 100%;
}
.el-descriptions__label:not(.is-bordered-label) {
  width: 150px;
  display: inline-block;
}
</style>